import {z} from 'zod';

import {messageSchema} from './MessageSchema';

/**
 * Schema for get all messages response
 */
export const getListMessagesResponseSchema = z.array(messageSchema);

export type GetListMessagesResponse = z.infer<typeof getListMessagesResponseSchema>;
